export enum LocalStorageKey {
  'USER' = 'USER'
}
